import { ScaleStyle, ValuesConfig } from "./types"
import { EasingFunctions, ValuesConfigToScaleValues } from "./utils"

// Maximum head start possible
// This value is the number of yards
export const MAX_HEAD_START = 25

export const SeasonFinishValuesConfig: ValuesConfig = {
	scaleStyle: ScaleStyle.Exponential,
	exponent: {
		base: 1.2,
		power: 1,
	},
	easing: {
		fn: EasingFunctions.easeOutCubic,
		reverse: true,
	},
	scaleFactor: 1,
}

export const PlayoffFinishValuesConfig: ValuesConfig = {
	scaleStyle: ScaleStyle.Exponential,
	exponent: {
		base: 1.2,
		power: 1,
	},
	easing: {
		fn: EasingFunctions.easeInCubic,
		reverse: false,
	},
	scaleFactor: 1,
}

export const ConsolationFinishValuesConfig: ValuesConfig = {
	scaleStyle: ScaleStyle.Exponential,
	exponent: {
		base: 1.2,
		power: 1,
	},
	easing: {
		fn: EasingFunctions.easeInCubic,
		reverse: false,
	},
	scaleFactor: 0.8,
}

export const SeasonFinishScaleValues = ValuesConfigToScaleValues(SeasonFinishValuesConfig)
export const PlayoffFinishScaleValues = ValuesConfigToScaleValues(PlayoffFinishValuesConfig)
export const ConsolationFinishScaleValues = ValuesConfigToScaleValues(ConsolationFinishValuesConfig)

// If you have different number of teams in playoffs and consolation, this will make the bracket with fewer teams match the same as the top N teams in the other bracket.
// Example, for 6 playoff teams and 4 consolation teams.
// Playoff teams: 1st = pow(base, power * 6), 2nd = pow(base, power * 5), ...
// Consolation teams:
// - value is true: 1st = pow(base, power * 6), 2nd = pow(base, power * 5), ...
// - value is false: 1st = pow(base, power * 4), 2nd = pow(base, power * 3), ...
export const CONSOLATION_FINISH_VALUE_SCALE_MATCHES_PLAYOFFS = false

// If your league did not have a consolation bracket, you can give a value to players who did not make playoffs
export const CONSOLATION_DEFAULT_VALUE = 0

// When combining season finish + playoff/consolation finish, you can configure how much each side matters
// Value should be between 0 and 1.
// Playoff/Consolation finish importance = 1 - SEASON_FINISH_IMPORTANCE
export const SEASON_FINISH_IMPORTANCE = 0.5

// Player speed ranges when running
// Use a yards / milliseconds scale
export const MIN_PLAYER_SPEED = 100.0 / 30000
export const MAX_PLAYER_SPEED = 100.0 / 18000

// Whether player speed changes should be changed through acceleration
// False = immediately change speed
export const PLAYER_SPEED_CHANGE_ACCELERATION = true

// How fast a player has to move to be sprinting or jogging
export const PLAYER_SPRINT_MIN_SPEED = ((MAX_PLAYER_SPEED - MIN_PLAYER_SPEED) * 2) / 3 + MIN_PLAYER_SPEED
export const PLAYER_JOG_MAX_SPEED = (MAX_PLAYER_SPEED - MIN_PLAYER_SPEED) / 3 + MIN_PLAYER_SPEED

// How often a player's speed should change, in milliseconds
export const MIN_PLAYER_SPEED_CHANGE_INTERVAL = 500
export const MAX_PLAYER_SPEED_CHANGE_INTERVAL = 1000

// How long to accelerate between speeds
export const PLAYER_SPEED_CHANGE_TIME = 500

// Chance for a player to trip while running - value is from 0 to 1
export const PLAYER_TRIP_CHANCE = 0.025

// How often to check if a player can trip, in milliseconds
export const PLAYER_TRIP_CHECK_INTERVAL = 500

// How long it takes a player to finish tripping
// This needs to always match the CSS animation duration
export const PLAYER_TRIP_ANIMATION_TIME = 1000

// How long a player should be tripped before they move again, in milliseconds
export const PLAYER_TRIP_DURATION = 1000

// Boost given to players who trip
export const PLAYER_TRIP_RECOVER_BOOST = 100.0 / 30000

// Extra time for trip recovery before calculating next speed
export const PLAYER_TRIP_RECOVER_TIME_BONUS = 1000

// Should players eat a hotdog before they start running?
export const PLAYER_EAT_HOTDOG_ENABLED = true

// Player hotdog eating speed ranges
// Use a milliseconds value for each
export const MIN_PLAYER_EAT_HOTDOG_TIME = 10000
export const MAX_PLAYER_EAT_HOTDOG_TIME = 15000

// Animation time in milliseconds for eating a hotdog
// This is for the repeated pattern of eating, not the whole time to eat
export const MIN_PLAYER_EAT_HOTDOG_ANIMATION_TIME = 250
export const MAX_PLAYER_EAT_HOTDOG_ANIMATION_TIME = 750
